/* global google */
import jwtDecode from 'jwt-decode';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { COOKIES, SIGN_IN_WITH_GOOGLE } from '../../brands/default/constants';
import { GOOGLE_IMG } from '../../config/constants/images';
import { setCookie } from '../../helpers/cookieSetter';
import { loadGoogleScript, gapiInit } from '../../helpers/googleService';
import { loginUser } from '../../helpers/googleServiceInternal';
import useToast from '../_generic/toast/UseToast';
import MediaButton from './MediaButton';

const GoogleButton = ({
  isLoginPage = false,
  registration = false,
  title = SIGN_IN_WITH_GOOGLE,
}) => {
  const toast = useToast();
  const dispatch = useDispatch();

  const handleGoogleLogin = (authResponse) => {
    // The ID token you need to pass to your backend:
    const token = authResponse?.credential;
    const decoded = jwtDecode(authResponse.credential); // Decode JWT token

    const email = decoded.email; // Extract email from token

    loginUser({
      dispatch,
      email,
      isLoginPage,
      registration,
      toast,
      token,
    });

    setCookie({
      expire: 365,
      key: COOKIES.userEmail,
      value: email,
    });
  };

  const initializeGIS = () => {
    const element = document.querySelector('#googleButton');
    gapiInit(handleGoogleLogin);
    google.accounts.id.renderButton(element, {
      shape: 'square',
      size: 'large',
      text: title,
      theme: 'filled_blue',
    });
  };

  useEffect(() => {
    loadGoogleScript(initializeGIS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MediaButton img={GOOGLE_IMG} title={title} type="google" />
    </>
  );
};

GoogleButton.propTypes = {
  isLoginPage: PropTypes.bool,
  registration: PropTypes.bool,
  title: PropTypes.string,
};

export default GoogleButton;
